import { IconNote } from '../../assets/icons/IconNote';
import type { TaskItemHeaderProps } from './types';

export function TaskItemHeader({ item, badge, metaTag, note }: TaskItemHeaderProps) {
    return (
        <div className="flex flex-col gap-xs w-full min-w-0">
            <div className="flex items-center justify-between gap-s w-full min-w-0">
                <span className="min-w-0 text-compact font-semibold text-primary-1000 truncate">
                    {item.title}
                </span>
                {item.amount !== null && (
                    <span className="shrink-0 text-s font-semibold tabular-nums text-content">
                        {item.amount}
                    </span>
                )}
            </div>
            {badge}
            {(metaTag || item.description) && (
                <div className="flex items-center gap-s min-w-0 mt-xs">
                    {metaTag}
                    {item.description && <p className="min-w-0 text-supporting font-normal text-content-subtle truncate">{item.description}</p>}
                </div>
            )}
            {note && (
                <p className="flex items-center gap-xs min-w-0 mt-xs text-supporting text-content">
                    <IconNote className="w-3 h-3 shrink-0" />
                    <span className="min-w-0 truncate" title={note}>{note}</span>
                </p>
            )}
        </div>
    );
}
